export default {
  computed: {
    isFirefoxDesktop: function () {
      const ua = window.navigator.userAgent
      return /Firefox/i.test(ua)
    },
  },
}
